export function headerNavigation() {
    const items = document.querySelectorAll('.site-header #header-menu > .nsfwspace-nav-item');

    items.forEach((item) => {
        const trigger = item.querySelector(':scope > a');
        const submenu = item.querySelector(':scope > .nsfwspace-nav-submenu');

        if (!trigger || !submenu) {
            return;
        }

        const open = () => {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
        };

        const close = () => {
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
        };

        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');

        item.addEventListener('pointerenter', open);
        item.addEventListener('pointerleave', close);
        item.addEventListener('focusin', open);
        item.addEventListener('focusout', (event) => {
            if (!item.contains(event.relatedTarget)) {
                close();
            }
        });
    });

    document.querySelectorAll('.nsfwspace-mobile-menu__toggle').forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const item = toggle.closest('.nsfwspace-mobile-menu__item');
            const open = !item.classList.contains('is-open');

            item.classList.toggle('is-open', open);
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    });
}
